<template>
  <v-container>
    <v-row style="margin-top: 40px;">
      <v-col cols="12" sm="12" md="12" lg="11" style="margin-left:  auto; margin-right: auto;" class="pa-6">
        <v-row justify="space-between">
          <span style="color: #222222; font-size: 25px; font-weight: 500;">My Time Off</span>
          <v-btn style="
              color: white;
              background-color: #0A7EA5;
              width: 230px;
            " to="/leave-request">
            Request Time Off
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row style="margin-top: 20px;">
      <v-col cols="12" sm="12" md="12" lg="11" style="margin-left:  auto; margin-right: auto;">
        <v-row>
          <v-col cols="6" lg="3" md="3">
            <v-card class="pa-6 box-show" elevation="0" style="background-color: #d0e9f1; margin:  auto;">
              <v-row justify="center" align="center">
                <v-col cols="2" md="2">
                  <v-row>
                    <v-icon size="25" style="color: #0A7EA5;">mdi-check-circle-outline</v-icon>
                  </v-row>
                </v-col>
                <v-col cols="10" md="9">
                  <v-row class="d-flex" align="center">
                    <span style="font-size: 16px;"><b>{{ vacation_day }}</b></span>&nbsp;
                    <span style="font-size: 12px; padding-top: 2px;">Days</span>
                    &nbsp;&nbsp;&nbsp;<span style="font-size: 16px;"><b>{{ vacation_hours }}</b></span>&nbsp;<span
                      style="font-size: 12px; padding-top: 2px;">Hours</span>
                  </v-row>
                  <v-row class="d-flex" align="center" style="margin-top: 10px;">
                    <span style="font-size: 10px;">Available to book time off</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="6" lg="3" md="3">
            <v-card class="pa-6 box-show" elevation="0" style="background-color: #fbf2d9; margin:  auto;">
              <v-row justify="center" align="center">
                <v-col cols="2" md="2">
                  <v-row>
                    <v-icon size="25" style="color: #ffbe5c;">mdi-alert-circle-outline</v-icon>
                  </v-row>
                </v-col>
                <v-col cols="10" md="10">
                  <v-row class="d-flex" align="center">
                    <span style="font-size: 16px;"><b>{{ pending_cont }}</b></span>&nbsp;
                    <span style="font-size: 12px; padding-top: 2px;">Pending Requests</span>
                  </v-row>
                  <v-row class="d-flex" align="center" style="margin-top: 10px;">
                    <span style="font-size: 10px;">Awaiting manager approval</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="6" lg="3" md="3">
            <v-card class="pa-6 box-show" elevation="0" style="background-color: #efefef;  margin:  auto;">
              <v-row justify="center" align="center">
                <v-col cols="2" md="2">
                  <v-row>
                    <v-icon size="25" style="color: #4e4e4e;">mdi-arrow-right-bold-circle-outline</v-icon>
                  </v-row>
                </v-col>
                <v-col cols="10" md="10">
                  <v-row class="d-flex" align="center">
                    <span style="font-size: 16px;"><b>{{ approver_day }}</b></span>&nbsp;
                    <span style="font-size: 12px; padding-top: 2px;">Days</span>
                    &nbsp;&nbsp;&nbsp;<span style="font-size: 16px;"><b>{{ approver_hours }}</b></span>&nbsp;<span
                      style="font-size: 12px; padding-top: 2px;">Hours</span>
                  </v-row>
                  <v-row class="d-flex" align="center" style="margin-top: 10px;">
                    <span style="font-size: 10px;">Upcoming</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="6" lg="3" md="3">
            <v-card class="pa-6 box-show" elevation="0" style="background-color: #efefef;  margin:  auto;">
              <v-row justify="center" align="center">
                <v-col cols="2" md="2">
                  <v-row>
                    <v-icon size="25" style="color: #4e4e4e;">mdi-flag-outline</v-icon>
                  </v-row>
                </v-col>
                <v-col cols="10" md="9">
                  <v-row class="d-flex" align="center">
                    <span style="font-size: 16px;"><b>{{ public_cont }}</b></span>&nbsp;
                    <span style="font-size: 12px; padding-top: 2px;">Public Holidays</span>
                  </v-row>
                  <v-row class="d-flex" align="center" style="margin-top: 10px;">
                    <span style="font-size: 10px;">This year</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row style="margin-top: 50px;">
      <v-col cols="10" lg="8" md="8" style="margin-left:  auto; margin-right: auto;">
        <v-row>
          <span style="color: #222222; font-size: 20px; font-weight: 500;">Time Off History</span>
        </v-row>
      </v-col>
    </v-row>
    <v-row style="min-height: 20rem;" v-if="leavehistory_list.length > 0">
      <v-col cols="10" lg="8" md="8" style="margin-left:  auto; margin-right: auto;">
        <v-row v-for="item in paginatedItems" :key="item.id" class="hover-bg"
          style="background-color: #f6f6f6 !important; margin: 20px 0 20px 0; border-radius: 10px;"
          @click="openLeave(item.id, item.status, item.type_count)">
          <v-col cols="1" md="1" class="d-flex flex-column justify-center">
            <v-icon style="
                    font-size: 40px;
                    color: #0A7EA5;
                  ">
              mdi-clipboard-text-clock-outline
            </v-icon>
          </v-col>
          <v-col cols="11" md="11">
            <v-row>
              <v-col cols="6" md="6">{{ item.leave_type }}</v-col>
              <v-col cols="6" md="6" class="d-flex justify-end">
                <span style="
                    color: #06A458; 
                    font-size: 11px; 
                    text-align: right; 
                  " v-if="item.approve_name == 'Approved'">
                  {{ item.approve_name }}
                </span>
                <span style="
                    color: red; 
                    font-size: 11px; 
                    text-align: right; 
                  " v-else-if="item.approve_name == 'Rejected'">
                  {{ item.approve_name }}
                </span>
                <span style="
                    color: #ffbe5c; 
                    font-size: 11px; 
                    text-align: right; 
                  " v-else>
                  {{ item.approve_name }}
                </span>
              </v-col>
            </v-row>
            <v-row style="margin-top: -30px;">
              <v-col cols="12" md="12">
                <span style="color: #222222; font-size: 11px; display: inline-block;">{{ item.description }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row style="margin-top: 100px; min-height: 13rem;" v-else>
      <v-col cols="10" lg="8" md="8" style="margin-left:  auto; margin-right: auto;">
        <v-row class="d-flex justify-center">
          <span style="color: #0A7EA5; font-size: 20px; display: inline-block; text-align: right;">No Upcoming Time
            Off</span>
        </v-row>
      </v-col>
    </v-row>
    <v-row style="margin-top: -20px;" v-if="itemsPerPage < leavehistory_list.length">
      <v-col cols="12" lg="8" md="8" style="margin-left:  auto; margin-right: auto;">
        <v-row class="d-flex justify-end">
          <div class="pagination-info">
            <v-btn v-if="!(page === 1)" icon @click="previousPage" style="color: #0A7EA5;">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <span style="font-size: 12px;">Page {{ page }} of {{ pageCount }}</span>

            <v-btn v-if="!(page === pageCount)" icon @click="nextPage" style="color: #0A7EA5;">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn v-else icon style="color: #0A7EA5;"> </v-btn>
          </div>
          <v-pagination v-model="page" :length="pageCount" :total-visible="5" class="hidden-pagination"
            total-visible="19"></v-pagination>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Leavelist.js";
import unity from "@/unity/unity";

export default {
  name: "leave-list",
  data(vm) {
    return {
      page: 1, // หน้าเริ่มต้น
      itemsPerPage: 3, // จำนวนรายการต่อหน้า
      leavehistory_list: [],
      search_status: "",
      day_sick: 0,
      day_sick_h: 0,
      day_business: 0,
      day_business_h: 0,
      day_vacation: 0,
      day_vacation_h: 0,
      day_oth: 0,
      day_oth_h: 0,
      day_use_leave: 0,
      day_use_leave_d: 0,
      day_use_leave_h: 0,
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status: ["Request", "Approve", "Inprocess", "Reject"],
      datefrom: null,
      dateto: null,
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      headers: [
        {
          text: "No.",
          value: "id",
          class: "bg-colorth tabletextwhite",
          width: "50px",
          sortable: false,
        },
        {
          text: "Date from",
          value: "startDate2",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Date to",
          value: "endDate2",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Requested",
          value: "min_amount",
          class: "bg-colorth tabletextwhite",
        },

        {
          text: "Leave Type",
          value: "leave_type",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Status",
          value: "approve_name",
          class: "bg-colorth tabletextwhite",
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
      dataAll: [],
      TypeLeaveArray: [],
      vacation_day: 0,
      vacation_hours: 0,
      approver_day: 0,
      approver_hours: 0,
      pending_cont: 0,
      public_cont: 0,
    };
  },

  async beforeCreate() {
    this.$store.state.navMenu = true;
  },

  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
    pageCount() {
      return Math.ceil(this.leavehistory_list.length / this.itemsPerPage); // คำนวณจำนวนหน้าทั้งหมด
    },
    paginatedItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.leavehistory_list.slice(start, end); // ดึงรายการที่ต้องแสดงในแต่ละหน้า
    },
  },

  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    await this.loadQuotaType();
    await this.loadleaveHistory();
    this.$hideLoader();
  },
  methods: {
    async loadleaveHistory() {
      const res_leave_history = await api.getListHistoryAll(
        localStorage.getItem(server.USER_ID)
      );

      if (res_leave_history.data && res_leave_history.data.length > 0) {
        const filteredData = res_leave_history.data.filter(
          (item) => Number(item.status) === 1 || Number(item.status) === 2,
        );
        this.pending_cont = filteredData.length;
      } else {
        this.pending_cont = 0;
      }

      for (const [index, item] of res_leave_history.data.entries()) {
        if (item.leave_type == "Sick Leave") {
          item.leave_type = "Sick";
        } else if (item.leave_type == "Vacation Leave") {
          item.leave_type = "Vacation";
        }
        var leave_day = 0;
        var leave_hours = 0;

        leave_day = Math.floor(Number(item.hours_amount) / 8);
        leave_hours = Number(item.hours_amount) - leave_day * 8;

        if (leave_day == 0) {
          if (leave_hours == 0) {
            item.description = `${item.data_date}`;
          } else if (leave_hours == 4) {
            item.description = item.description = `${item.data_date} (half day)`;
          } else if (leave_hours == 8) {
            item.description = item.description = `${item.data_date} (full day)`;
          } else {
            item.description = item.description = `${item.data_date} (${leave_hours} hours)`;
          }
        } else {
          if (leave_hours == 0) {
            if (leave_day > 1) {
              item.description = `${item.data_date} (${leave_day} day)`;
            } else {
              item.description = `${item.data_date} (full day)`;
            }
          } else {
            item.description = item.description = `${item.data_date} (${leave_day} day ${leave_hours} hours)`;
          }
        }
      }
      this.leavehistory_list = res_leave_history.data;
    },
    async loadQuotaType() {
      const res_quota = await api.getListByUserDashboard(
        localStorage.getItem(server.USER_ID)
      );
      if (res_quota.data && res_quota.data.length > 0) {
        var canuse_leave = 0;
        canuse_leave = Number(res_quota.data[0].leave_can_use);
        this.vacation_day = Math.floor(canuse_leave);
        this.vacation_hours = (canuse_leave - this.vacation_day) * 8;
      } else {
        this.vacation_day = 0;
        this.vacation_hours = 0;
      }

      const res_holiday = await api.getAllYear(
        Number(localStorage.getItem(server.COMPANYID))
      );
      if (res_holiday.data && res_holiday.data.length > 0) {
        this.public_cont = res_holiday.data.length;
      } else {
        this.public_cont = 0;
      }

      const res_approval = await api.getAllByApproval(
        Number(localStorage.getItem(server.USER_ID))
      );
      if (res_approval.data && res_approval.data.length > 0) {
        // console.log("res_approval.data: ");
        // console.log(res_approval.data);
        this.approver_day = Math.floor(
          Number(res_approval.data[0].amount) / 60 / 8
        );
        this.approver_hours = Math.floor(
          (Number(res_approval.data[0].amount) - this.approver_day * 60 * 8) /
          60
        );
      } else {
        this.approver_day = 0;
        this.approver_hours = 0;
      }
    },
    async openLeave(id, status, type_count) {
      if (status == 1) {
        if (type_count) {
          this.$router.push(`/leave-request-edit/${id}`);
        } else {
          this.$router.push(`/leave-request-waiting/${id}/leave`);
        }
      } else {
        this.$router.push(`/leave-request-waiting/${id}/leave`);
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page -= 1;
      }
    },
    nextPage() {
      if (this.page < this.pageCount) {
        this.page += 1;
      }
    },
  },
};
</script>

<style scoped>
.bg-colorth {
  background-color: #595959;
  color: red;
}

.text-left {
  color: aliceblue;
}

.widthsizesearch {
  width: 70%;
}

.theme--light.v-card {
  border-color: #9f9f9f;
}

.hover-bg {
  transition: background-color 0.3s ease;
  cursor: pointer;
}

.hover-bg:hover {
  background-color: #daf2fa;
  /* สีที่ต้องการเมื่อ hover */
}

.pagination-info {
  font-size: 14px;
  /* ขนาดฟอนต์ */
  color: #0a7ea5;
  /* เปลี่ยนสีข้อความ */
}

/* ซ่อน pagination */
.hidden-pagination {
  display: none;
}

.box-show {
  height: 60px !important;
  border-radius: 8px;
}
</style>
